/**
 * @component ModalPopup
 * @description 비즈니스 목적: 오류/안내 문구를 모달 형태로 표시하고 확인 버튼으로 닫습니다.
 *              onCancel을 전달하면 취소 버튼이 함께 표시되어 확인(confirm) 용도로도 사용할 수 있습니다.
 */

export default function ModalPopup({
  isOpen,
  message,
  onConfirm,
  onCancel,
  title = '안내',
  confirmLabel = '확인',
  cancelLabel = '취소',
}) {
  if (!isOpen) {
    return null;
  }

  // [비즈니스] 되돌릴 수 없는 작업은 사용자가 한 번 더 확인할 수 있어야 합니다.
  //            취소 동작이 필요한 호출부만 onCancel을 넘기며, 기존 안내용 호출은 그대로 단일 버튼으로 동작합니다.
  const isConfirmDialog = typeof onCancel === 'function';

  return (
    <div className="modal-overlay" role="presentation">
      <div className="modal-popup" role="dialog" aria-modal="true" aria-labelledby="modal-popup-title">
        <h2 id="modal-popup-title" className="modal-popup-title">
          {title}
        </h2>
        <p className="modal-popup-message">{message}</p>
        <div className={`modal-popup-actions${isConfirmDialog ? ' modal-popup-actions-dual' : ''}`}>
          {isConfirmDialog && (
            <button type="button" className="secondary-button" onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
          <button type="button" className="primary-button" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
